module.exports = __webpack_public_path__ + "img/MIT_Gob.Web_SET.75cefbea.png";